import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class FeedbackDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  Id?: number;
  @ApiProperty()
  @MaxLength(500, { message: "allows maximum 500 characters" })
  feedBackTitle:string;
  @ApiProperty()
  @MaxLength(500, { message: "allows maximum 500 characters" })
  feedBackDesc:string;
  @ApiProperty()
  @IsNotEmpty()
  userId:number; 
  createdAt : Date;
  @ApiProperty({
    minimum:1,
    default:1
  })
  versionFlag : number;
}



